module.exports = __webpack_public_path__ + "static/media/icon2-green.aa1f471a.svg";